import type { NapiCancellationOption } from "@app/types/napi-v2-cancellation-types";
import type { CreditType } from "@app/types/napi-v2-request-type";

export function getRefundMethod(
  cancellation_options: NapiCancellationOption[]
): CreditType {
  if (!cancellation_options.length) {
    throw Error("No cancellation option");
  }

  const has_busbud_credits =
    // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    cancellation_options[0].credit_types.includes("busbud_credits");
  // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const is_only_voucher_refund = cancellation_options[0].credit_types.every(
    credit_type => credit_type === "voucher"
  );

  if (has_busbud_credits) {
    return "busbud_credits";
  } else if (is_only_voucher_refund) {
    return "voucher";
  } else {
    return "original_payment_method";
  }
}
